<template>
    <div id="master-sidebar" class="h-100 d-flex flex-column justify-content-between bg-light shadow">
        <div class="d-flex flex-column">
            <div class="d-flex flex-column">
                <span class="router-link-header">My Files</span>
                <router-link class="router-link" to="/">
                    <span>Dashboard</span>
                    <font-awesome-icon :icon="['fad', 'chart-line']" fixed-width />
                </router-link>
                <router-link class="router-link" :to="{name: 'receivedfiles'}">
                    <span>Received Files</span>
                    <font-awesome-icon :icon="['fad', 'folder-open']" fixed-width></font-awesome-icon>
                </router-link>
                <router-link class="router-link" to="/uploadfile">
                    <span>Upload Files</span>
                    <font-awesome-icon :icon="['fad', 'cloud-upload']" fixed-width></font-awesome-icon>
                </router-link>
            </div>
        </div>
        <div class="d-flex flex-column settings-nav-section">
            <span class="router-link-header">My Account</span>
            <router-link class="router-link" to="/settings">
                <span>Settings</span>
                <font-awesome-icon :icon="['fad', 'cog']" fixed-width />
            </router-link>
            <router-link class="router-link" :to="{name: 'login'}">
                <span>Log Out</span>
                <font-awesome-icon :icon="['fad', 'sign-out']" fixed-width></font-awesome-icon>
            </router-link>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    #master-sidebar {
        width: 300px;
        z-index: 8;
    }

    .router-link-header {
        padding: 1em 0.75em 0em;
        text-transform: uppercase;
        font-size: 0.9em;
        font-weight: 600;
        width: 100%;
        color: #aaaaaa;
    }

    .settings-nav-section .router-link-header {
        padding-top: 0.5em;
    }

    .router-link {
        padding: 0.5em 0.75em 0.5em 1.25em;
        margin: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-decoration: none;
        transition: 0.25s all ease;
        &.router-link-exact-active {
            background: rgba(0,0,0,0.05);
        }
        &:hover {
            background: rgba(0,0,0,0.1);
            padding-right: 1em;
        }
    }

    .settings-nav-section {
        border-top: 3px solid #dddddd;
    }
</style>


// WEBPACK FOOTER //
// src/components/master/master-sidebar.vue